import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  UsersIcon,
  BriefcaseIcon,
  EnvelopeIcon,
  ChatBubbleLeftRightIcon,
  PencilSquareIcon,
} from '@heroicons/react/24/outline';

const allNavigation = [
  { name: 'Пользователи', href: '/users', icon: UsersIcon },
  { name: 'Менеджеры', href: '/managers', icon: BriefcaseIcon },
  { name: 'Рассылки', href: '/mailings', icon: EnvelopeIcon },
  { name: 'Центр коммуникаций', href: '/dialogs', icon: ChatBubbleLeftRightIcon },
  { name: 'Промпты', href: '/prompts', icon: PencilSquareIcon },
];

// Для SMM менеджера доступны только: рассылки, коммуникации, промпты (база знаний)
const smmNavigation = ['/mailings', '/dialogs', '/prompts'];

function getNavigation(user) {
  const role = (user?.role || '').toLowerCase();
  if (role === 'smm_manager') {
    return allNavigation.filter(item => smmNavigation.includes(item.href));
  }
  return allNavigation;
}

function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      <div className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <h1>Иван Везёт</h1>
          <button className="sidebar-close" onClick={() => setSidebarOpen(false)}>
            ×
          </button>
        </div>

        <nav className="sidebar-nav">
          {getNavigation(user).map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`nav-link ${isActive ? 'active' : ''}`}
                onClick={() => setSidebarOpen(false)}
              >
                <item.icon className="nav-icon" style={{ width: '1.25rem', height: '1.25rem' }} />
                <span className="nav-label">{item.name}</span>
              </Link>
            );
          })}
        </nav>
      </div>

      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      <div className="main-container">
        <header className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <button className="menu-btn" onClick={() => setSidebarOpen(true)}>
            ☰
          </button>
          <div className="header-right" style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span className="user-name">{user?.username}</span>
            <button onClick={handleLogout} className="logout-btn">
              Выход
            </button>
          </div>
        </header>

        <main className={`main-content${location.pathname === '/dialogs' ? ' no-padding' : ''}`}>{children}</main>
      </div>
    </div>
  );
}

export default Layout;